// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kXDn","col":"styles_col__ysuc2"};